import styled from 'styled-components';
import { colors } from '../../constants/colors';
import { mediaLgDown, mediaSmDown } from '../../theme/helpers/css';
import LogoOval from 'Components/Icon/LogoOval';

const BANNER_HEIGHT = 48;
export const NEWS_BANNER_MOBILE_HEIGHT = 91;

export const Container = styled.div`
  min-height: ${BANNER_HEIGHT}px;
  width: 100%;
  background-color: ${colors.sweetCorn};
  display: flex;
  justify-content: center;
  position: relative;
  padding: 0 30px 0 20px;

  ${mediaSmDown`
    padding: 18px;
    position: fixed;
    top: 0;
    height: ${NEWS_BANNER_MOBILE_HEIGHT}px;
    z-index: 201
  `}
`;

export const Wrapper = styled.div`
  width: 1300px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${mediaLgDown`
    justify-content: center;
  `}
`;

export const News = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  ${mediaSmDown`
    flex-direction: column;
    gap: 5px;
  `}
`;

export const Image = styled.img`
  width: 120px;
  height: ${BANNER_HEIGHT}px;
  ${mediaLgDown`
    display: none
  `}
`;

export const Text = styled.span`
  font-size: 14px;
  line-height: 18px;
  letter-spacing: -0.2px;
  color: ${colors.blackRussian};
  cursor: pointer;

  ${mediaSmDown`
    font-size: 12px;
    line-height: 16px;
    text-align: center;
   
  `}
`;

export const Dot = styled(LogoOval)`
  color: ${colors.blackRussian};

  ${mediaSmDown`
   display: none
   
  `}
`;

export const CloseIconWrap = styled.div`
  position: absolute;
  right: 25px;
  top: ${BANNER_HEIGHT / 2 - 6}px;
  cursor: pointer;
`;

export const TextRow = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
`;
